import { EXPORT, INFO } from "../iconsSVG/IconsSVG";
import { Row, Col, Accordion } from "react-bootstrap";
import "./Ayuda.css";
import { Link } from "react-router-dom";

function PestanaAyuda() {
  return (
    <div>
      <div className="center">
        <Accordion defaultActiveKey="0" className="w-100 glob-custom-accordion-button-color">
          <Accordion.Item eventKey="0">
            <Accordion.Header onClick={() => window.open('https://www.oepm.es/es/sobre-OEPM/atencion-al-ciudadano/contacto/', '_blank')}>
              <span className="p-0 m-0 ps-3 pb-1 ayuda-acordion-titulo">Contacto</span>
            </Accordion.Header>
            {/* <Accordion.Body>                          
              
            </Accordion.Body> */}
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className="w-100 glob-custom-accordion-button-color">
          <Accordion.Item eventKey="0">
            <Accordion.Header>              
              <span className="p-0 m-0 ps-3 pb-1 ayuda-acordion-titulo"> Errores y sugerencias</span>
            </Accordion.Header>
            <Accordion.Body>                          
              <p className="px-3  ayuda-acordion-cuerpo">                
                <a href="mailto:soportefuncional@oepm.es?subject=BOPI">soportefuncional@oepm.es</a>
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>          
        <Accordion  defaultActiveKey={null} className="w-100 glob-custom-accordion-button-color">
          <Accordion.Item eventKey="0">
            <Accordion.Header>              
              {/* <div className="fondo-blanco-icono justify-content-start">
                <INFO color_icono="#203C77" color_fondo="#E9F1F7" className="p-0 m-0"/>
              </div> */}
              <span className="p-0 m-0 ps-3 pb-1 ayuda-acordion-titulo">Cobertura de la base de datos</span>
            </Accordion.Header>
            <Accordion.Body>
              <p className="px-3 ayuda-acordion-cuerpo">
              La Consulta de Publicaciones de la OEPM se actualiza diariamente y 
              permite consultar los datos de las publicaciones realizadas en el Boletín Oficial de la Propiedad Intelectual desde abril de 1999 para los Tomos 1 y 3 y desde febrero de 1984 para el Tomo 2.
              </p>
              <p className="px-3 ayuda-acordion-cuerpo">
                Para cualquier consulta puede dirigirse a{" "}
                <a href="mailto:soportefuncional@oepm.es?subject=BOPI">soportefuncional@oepm.es</a>
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey={null}className="w-100 glob-custom-accordion-button-color">
          <Accordion.Item eventKey="0">
            <Accordion.Header>                            
              <span className="p-0 m-0 ps-3 pb-1 ayuda-acordion-titulo">Manual para descarga de archivos PDF, XML, HTML</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="ayuda-seccion">
                <p className="px-3 ayuda-acordion-cuerpo-negrita">
                Suscripción:
                </p>
                <p className="px-3 ayuda-acordion-cuerpo">
                Se accede, dentro de la presente aplicación, a un 
                <Link to="/subscripcion-boletin" className="m-1">
                formulario
                </Link>
                {/* <a href="/bopi/subscripcion-boletin" className="m-0 p-0"> formulario </a> */}
                que permite suscribirse al Boletín Oficial de la Propiedad Industrial en formato PDF. Para ello deberán rellenarse los campos correspondientes y marcarse el tomo/tomos deseados, lo que permitirá recibir por correo electrónico los enlaces a las publicaciones de BOPI diario en PDF.
                </p>
                
              </div>
              <br />
              <div className="ayuda-seccion m-0 p-0">
                <p className="px-3 ayuda-acordion-cuerpo-negrita">
                Registro:
                </p>
                <p className="px-3 ayuda-acordion-cuerpo">
                Se redirige a un 
                <a href="https://www.oepm.es/es/sobre-OEPM/servicios-al-ciudadano/servicios-gratuitos/Servicios-web-de-la-OEPM/lopd/" 
                  target="_blank" rel="noopener noreferrer" className="m-0 p-0"> fomulario </a>
                del Portal web de la OEPM que permite registrarse con la finalidad de habilitar, dentro de la presente aplicación, el acceso mediante usuario y clave para las 
                <Link to="/descarga" className="m-1" >
                  descargas
                </Link>
                {/* <a href="/bopi/" className="m-0 p-0"> descargas </a> */}
                del BOPI en formato XML y HTML.
                </p>
                {/* <a href="https://www.oepm.es/es/sobre-OEPM/servicios-al-ciudadano/servicios-gratuitos/Servicios-web-de-la-OEPM/lopd/" 
                target="_blank"  
                rel="noopener noreferrer" 
                className="ms-2 ps-2">
                  registrarse
                </a> */}
                
              </div>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}

export default PestanaAyuda;